/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useIdleTimer } from "react-idle-timer";
import { Modal, Result } from "antd";
import Text from "antd/lib/typography/Text";
import { useMsal } from "@azure/msal-react";

export default function IdleTimer() {
	const timeout = 3600000; // 60 mins (1,000 x 60 x 60)
	const [remaining, setRemaining] = useState(timeout);
	const { instance } = useMsal();

	const handleOnIdle = () => {
		instance.logoutRedirect({
			postLogoutRedirectUri: "/#/SignedOut",
		});
	};

	const { getRemainingTime } = useIdleTimer({
		timeout,
		onIdle: handleOnIdle,
		crossTab: {
			emitOnAllTabs: true,
		},
	});

	useEffect(() => {
		setRemaining(getRemainingTime());

		setInterval(() => {
			setRemaining(getRemainingTime());
		}, 1000);
	}, []);

	return (
		<Modal open={remaining < 300000} footer={null} closable={false}>
			<Result
				title="Are you still there?"
				subTitle="You're about to be automatically signed out due to inactivity. Click anywhere to stay signed in."
			>
				<Text strong>
					Time Remaining: {Number(remaining / 1000).toFixed(0)}{" "}
					seconds
				</Text>
			</Result>
		</Modal>
	);
}
